module.exports = __webpack_public_path__ + "img/ic_alert.47665f35.svg";